<template>
<section>
  <div style="background: white; padding:5px">
    <b-field grouped group-multiline>
      

        <b-field grouped class="panel-icon" style="margin-left: 0em;">
          <div v-for="(channel, index) in contact.channels" v-bind:key="index">
    
            <span class="panel-icon" style="font-size: 1.4em;">
              <i v-if="channel.type == 'phone'" class="fas fa-phone" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
              <i v-if="channel.type == 'email'" class="fas fa-envelope" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
              <i v-if="channel.type == 'facebook'" class="fab fa-facebook" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>
              <i v-if="channel.type == 'skype'" class="fab fa-skype" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
              <i v-if="channel.type == 'twitter'" class="fab fa-twitter" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
              <i v-if="channel.type == 'address'" class="fas fa-home" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
              <i v-if="channel.type == 'other'" class="fas fa-bookmark" style="color: darkgrey; margin-right: 1em;" aria-hidden="true"></i>            
            </span>
            
          </div>
        </b-field>

      <!-- </b-field> -->
    </b-field>  
    <!-- <b-field grouped group-multiline style="line-height: 0.3;">
      <b-field>
        <span style="font-size: 0.8em;">{{contact.message}}</span>
      </b-field>
      <b-field>

    
        <span style="font-size: 0.8em;">{{contact.status}}</span>
      </b-field>
    </b-field>   -->
  </div>
    
</section>
</template>

<script>

export default {

  name: 'ShowChannelIcons',
  components: {
    
  },
  // data() {
  //   return  {
  //   }
  // },
  props: {
    contact: {},
  },
  computed: {
    // isRead: this.contact.status==='read' ? true: false
  },
  methods: {
    // isread (status) {
    //   if (status==='read') return true;
    //   return false;
    // }
    // clickMe () {
    //   window.alert(this.msg)
    // }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .read {
    background: green;
  }
</style>